// API client for the QA dashboard (migrated from the standalone Streamlit
// ck-qa-dashboard). Backend endpoints live in the dashone monorepo (apps/api):
//   GET /admin/qa/checks          — data-quality check results (dws_meta_qa_checks)
//   GET /admin/qa/kpis            — platform-level KPIs, current + previous refresh
//   GET /admin/qa/franchise-kpis  — live franchise-level KPIs for one (id_client, country)
// All are dashmote-admin only and cached 1h server-side. Pass { forceRefresh: true }
// to append ?force_refresh=true (bypass + refill the backend cache slot).
// Mirrors the auth/URL pattern of fetchDashboardAvailability in authApi.js.
// Backend: the QA dashboard endpoints.
import { getApiUrl } from "../utils/envConfig";
import { makeAuthenticatedRequest } from "./authApi";

// Build a query string from defined, non-empty params (encodes keys + values).
const buildQuery = (params) => {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
  return parts.length ? `?${parts.join("&")}` : "";
};

// Data-quality checks for a refresh (defaults to the latest available).
// Returns { refresh, checks: { [check_id]: [{ id_client, country, metrics }] } }.
export const fetchQaChecks = async ({ refresh, forceRefresh = false } = {}) => {
  try {
    const qs = buildQuery({ refresh, force_refresh: forceRefresh || undefined });
    return await makeAuthenticatedRequest(`${getApiUrl()}/admin/qa/checks${qs}`);
  } catch (error) {
    throw new Error("Failed fetching QA checks: " + error.message);
  }
};

// Platform-level KPIs for the current + previous refresh (optionally filtered).
// Returns { refresh, prev_refresh, rows: QaKpiRow[] }.
export const fetchQaKpis = async ({ refresh, idClient, country, forceRefresh = false } = {}) => {
  try {
    const qs = buildQuery({ refresh, id_client: idClient, country, force_refresh: forceRefresh || undefined });
    return await makeAuthenticatedRequest(`${getApiUrl()}/admin/qa/kpis${qs}`);
  } catch (error) {
    throw new Error("Failed fetching QA KPIs: " + error.message);
  }
};

// Live franchise-level KPIs for one workspace + country (both required).
// Returns { refresh, prev_refresh, rows: QaFranchiseKpiRow[] }.
export const fetchQaFranchiseKpis = async ({ idClient, country, refresh, forceRefresh = false } = {}) => {
  try {
    const qs = buildQuery({ id_client: idClient, country, refresh, force_refresh: forceRefresh || undefined });
    return await makeAuthenticatedRequest(`${getApiUrl()}/admin/qa/franchise-kpis${qs}`);
  } catch (error) {
    throw new Error("Failed fetching franchise KPIs: " + error.message);
  }
};
